import { type Student } from "@forento/core/models/user"

import { type CsvColumn, downloadCsv } from "~/utilities/csv"

export type UserItem = Student & { lastActiveDate: Date | null }

export const productTypes = [
	{ key: "courses", singular: "course", plural: "courses" },
	{ key: "videos", singular: "video", plural: "videos" },
	{ key: "downloadables", singular: "downloadable", plural: "downloadables" },
	{ key: "sessions", singular: "session", plural: "sessions" },
	{ key: "events", singular: "event", plural: "events" },
] as const satisfies { key: keyof Student["purchases"]; singular: string; plural: string }[]

export function getProductCount(user: UserItem): number {
	return productTypes.reduce((count, type) => count + user.purchases[type.key], 0)
}

export function getFullName(user: UserItem): string {
	return `${user.firstName} ${user.lastName}`.trim()
}

export function downloadUsersCsv(users: UserItem[], { includeMembership }: { includeMembership: boolean }) {
	const columns: CsvColumn<UserItem>[] = [
		{ title: "First name", value: user => user.firstName },
		{ title: "Last name", value: user => user.lastName },
		{ title: "Email", value: user => user.email },
		{ title: "Phone number", value: user => user.phoneNumber ?? "" },
		{ title: "Register date", value: user => user.registerDate.toISOString() },
		{ title: "Last active date", value: user => user.lastActiveDate?.toISOString() ?? "" },
		...(includeMembership
			? [{ title: "Membership", value: (user: UserItem) => user.membership?.title ?? "" }]
			: []),
		...productTypes.map(type => ({
			title: `Purchased ${type.plural}`,
			value: (user: UserItem) => user.purchases[type.key].toString(),
		})),
	]

	downloadCsv("Users.csv", columns, users)
}
